import React, { FC } from 'react'
import ContentLoader from 'react-content-loader'
import { styled } from '@creditas/stylitas'

const Container = styled.div`
  width: 30%;
  max-width: 285px;
  border-right: 1px solid #d8d8d8;

  h3 {
    font-weight: bold;
    font-size: 20px;
    line-height: 28px;
    margin-bottom: 12px;
  }
`

const LeadInfoLoading: FC = () => (
  <Container>
    <ContentLoader height={130} width={200}>
      <rect x="0" y="4" rx="10" ry="10" width="170" height="20" />
      <rect x="0" y="44" rx="8" ry="8" width="120" height="16" />
      <rect x="0" y="68" rx="8" ry="8" width="130" height="16" />
      <rect x="0" y="92" rx="8" ry="8" width="200" height="16" />
    </ContentLoader>
  </Container>
)

export { LeadInfoLoading }
